module.exports = __webpack_public_path__ + "img/tr.fed7c938.jpg";